import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Register } from './pages/authenticate/register/Register';
import { ForgotPassword } from './pages/authenticate/forgot_password';
import { EmailVerification } from './pages/authenticate/email_verification/EmailVerification';
import { CreateNewPassword } from './pages/authenticate/create_new_password';
import { Login } from './pages/authenticate/Login';
import { DashboardMenu } from './pages/dashboard/dashboard_menu';
import { Reseller } from './pages/dashboard/reseller';
import { Employee } from './pages/dashboard/employee';
import { Nas } from './pages/dashboard/master_data/nas';
import { Pop } from './pages/dashboard/master_data/pop';
import { Odp } from './pages/dashboard/master_data/odp';
import { PppoeProfile } from './pages/dashboard/pppoe/profile';
import { PppoeUser } from './pages/dashboard/pppoe/user';
import { PppoeUserCreate } from './pages/dashboard/pppoe/user/Create';

import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";

import { UserManager } from './pages/dashboard/user_manager';
import { Finance, FinanceReport } from './pages/dashboard/finance/report';
import { Setting } from './pages/dashboard/setting';
import { PppoePsb } from './pages/dashboard/pppoe/psb';
import { PppoePsbCreate } from './pages/dashboard/pppoe/psb/Create';
import { Odc } from './pages/dashboard/master_data/odc';
import { PopDetail } from './pages/dashboard/master_data/pop/detail';
import { PopCreate } from './pages/dashboard/master_data/pop/PopCreate';
import { PppoeUserDetail } from './pages/dashboard/pppoe/user/detail';
import { Ticket } from './pages/dashboard/ticket';
import { LandingPage } from './pages/landing_page';
import { TicketDetail } from './pages/dashboard/ticket/detail';
import { UserDetail } from './pages/dashboard/user_manager/detail';
import { ResellerDetail } from './pages/dashboard/reseller/detail';
import { PppoePsbDetail } from './pages/dashboard/pppoe/psb/detail';
import { LogisticMonitoring } from './pages/dashboard/logistic/monitoring';
import { LogisticMonitoringDetail } from './pages/dashboard/logistic/detail';
import { GenieAcs } from './pages/dashboard/genie_acs';
import WhatsAppPage from './pages/dashboard/whatsapp';
import { OdcDetail } from './pages/dashboard/master_data/odc/detail';
import { NasDetail } from './pages/dashboard/master_data/nas/detail';
import { MikrotikConfigGenerator } from './pages/dashboard/master_data/nas/detail/MikrotikConfigGenerator';
import { Presence } from './pages/dashboard/presence';
import { OdcCreate } from './pages/dashboard/master_data/odc/OdcCreate';
import { OdpCreate } from './pages/dashboard/master_data/odp/OdpCreate';
import { Mapping } from './pages/dashboard/master_data/mapping';
import { IsolirPage } from './pages/inform_pages/IsolirPage';
import { GenieAcsDetail } from './pages/dashboard/genie_acs/detail';
import { LogisticMovement } from './pages/dashboard/logistic/movement';
import { Olt } from './pages/dashboard/master_data/olt';
import { OltCreate } from './pages/dashboard/master_data/olt/sub_feature/Create';
import { WhatsAppMessagePage } from './pages/dashboard/whatsapp/message';
import { WhatsAppNumberPage } from './pages/dashboard/whatsapp/number';
import { PresenceForm } from './pages/dashboard/presence/form';
import { PaymentGatwayPage } from './pages/dashboard/payment_gateway';
import { Invoice } from './pages/dashboard/invoice/list';
import { InvoiceGroup } from './pages/dashboard/invoice/group';
import { InvoiceGroupDetail } from './pages/dashboard/invoice/group/detail';
import { HotspotProfile } from './pages/dashboard/hotspot/profile';
import { Mitra } from './pages/dashboard/agensi/mitra';
import { Marketing } from './pages/dashboard/agensi/marketing';
import { PromiseToPay } from './pages/dashboard/invoice/promise_to_pay';
import { VocherPage } from './pages/dashboard/hotspot/vocher';
import { NotificationPage } from './pages/dashboard/notification';
import { JobdeskPage } from './pages/dashboard/jobdesk_page';
import { JobdeskDetailPage } from './pages/dashboard/jobdesk_page/detail';
import { MitraDetail } from './pages/dashboard/agensi/mitra/detail';
import { MarketingDetail } from './pages/dashboard/agensi/marketing/detail';
import { ComingSoon } from './pages/information/coming_soon';
import { CustomerPage } from './pages/dashboard/customer';
import { PackagePage } from './pages/dashboard/package';
import { PackageDetail } from './pages/dashboard/package/detail';
import { WhatsAppManager } from './pages/dashboard/whatsapp/wa_page';
import { WhatsAppTemplatePage } from './pages/dashboard/whatsapp/template';
import { WhatsAppTemplateCreate } from './pages/dashboard/whatsapp/template/create';
import Checkout from './pages/checkout';
import { DiagramManagement } from './pages/dashboard/master_data/diagram';
import { TemplateVoucherPage } from './pages/dashboard/hotspot/template';
import { Transaction } from './pages/dashboard/finance/report/transaction';
import { Hutang } from './pages/dashboard/finance/report/hutang';
import { Piutang } from './pages/dashboard/finance/report/piutang';
import { PiutangTransaction } from './pages/dashboard/finance/report/piutang/transaction';
import { BankAccount } from './pages/dashboard/finance/bank_account';
import { CentralOdc } from './pages/dashboard/master_data/central_odc';
import { CentralOdcCreate } from './pages/dashboard/master_data/central_odc/CentralOdcCreate';
import { CentralOdcDetail } from './pages/dashboard/master_data/central_odc/detail';
import { TaxesPage } from './pages/dashboard/finance/tax';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/checkout" Component={Checkout} />

      <Route path="/" Component={LandingPage} />
      <Route path="/login" Component={Login} />
      {/* <Route path="/register" Component={Register} /> */}
      <Route path="/forgot-password" Component={ForgotPassword} />
      <Route path="/email-verification" Component={EmailVerification} />
      <Route path="/create-new-password" Component={CreateNewPassword} />

      <Route path="/isolir" Component={IsolirPage} />
      <Route path="/coming-soon" Component={ComingSoon} />

      <Route path="/dashboard-menu" Component={DashboardMenu} />

      <Route path="/dashboard/package" Component={PackagePage} />
      <Route path="/dashboard/package/detail/:id" Component={PackageDetail} />


      <Route path="/dashboard/customer" Component={CustomerPage} />

      <Route path="/dashboard/master-data/nas" Component={Nas} />
      <Route path="/dashboard/master-data/nas/detail/:id" Component={NasDetail} />
      <Route path="/dashboard/master-data/nas/detail/:id/config" Component={MikrotikConfigGenerator} />

      <Route path="/dashboard/master-data/olt" Component={Olt} />
      <Route path="/dashboard/master-data/olt/create" Component={OltCreate} />

      <Route path="/dashboard/master-data/pop" Component={Pop} />
      <Route path="/dashboard/master-data/pop/create" Component={PopCreate} />
      <Route path="/dashboard/master-data/pop/detail/:id" Component={PopDetail} />

      <Route path="/dashboard/master-data/central-odc" Component={CentralOdc} />
      <Route path="/dashboard/master-data/central-odc/detail/:id" Component={CentralOdcDetail} />
      <Route path="/dashboard/master-data/central-odc/create" Component={CentralOdcCreate} />

      <Route path="/dashboard/master-data/odc" Component={Odc} />
      <Route path="/dashboard/master-data/odc/create" Component={OdcCreate} />
      <Route path="/dashboard/master-data/odc/detail/:id" Component={OdcDetail} />
      <Route path="/dashboard/master-data/odp" Component={Odp} />
      <Route path="/dashboard/master-data/odp/create" Component={OdpCreate} />
      <Route path="/dashboard/master-data/mapping" Component={Mapping} />
      <Route path="/dashboard/master-data/diagram" Component={DiagramManagement} />

      <Route path="/dashboard/pppoe/profile" Component={PppoeProfile} />
      <Route path="/dashboard/pppoe/user" Component={PppoeUser} />
      <Route path="/dashboard/pppoe/user/detail/:id" Component={PppoeUserDetail} />
      <Route path="/dashboard/pppoe/user/create" Component={PppoeUserCreate} />
      <Route path="/dashboard/pppoe/psb" Component={PppoePsb} />`
      <Route path="/dashboard/pppoe/psb/detail/:id" Component={PppoePsbDetail} />
      <Route path="/dashboard/pppoe/psb/create" Component={PppoePsbCreate} />

      <Route path="/dashboard/hotspot/profile" Component={HotspotProfile} />
      <Route path="/dashboard/hotspot/voucher" Component={VocherPage} />
      <Route path="/dashboard/hotspot/template" Component={TemplateVoucherPage} />

      <Route path="/dashboard/genie-acs" Component={GenieAcs} />
      <Route path="/dashboard/genie-acs/detail/:id" Component={GenieAcsDetail} />

      <Route path='/dashboard/logistic/monitoring' Component={LogisticMonitoring} />
      <Route path='/dashboard/logistic/monitoring/detail/:id' Component={LogisticMonitoringDetail} />
      <Route path='/dashboard/logistic/movement' Component={LogisticMovement} />

      <Route path='/dashboard/agensi/mitra' Component={Mitra} />
      <Route path='/dashboard/agensi/mitra/detail/:id' Component={MitraDetail} />
      <Route path='/dashboard/agensi/marketing' Component={Marketing} />
      <Route path='/dashboard/agensi/marketing/detail/:id' Component={MarketingDetail} />
      <Route path="/dashboard/agensi/reseller" Component={Reseller} />
      <Route path="/dashboard/agensi/reseller/detail/:id" Component={ResellerDetail} />

      <Route path="/dashboard/invoice/group" Component={InvoiceGroup} />
      <Route path="/dashboard/invoice/list" Component={Invoice} />
      <Route path="/dashboard/invoice/promise-to-pay" Component={PromiseToPay} />
      <Route path="/dashboard/invoice/detail/:id" Component={InvoiceGroupDetail} />


      <Route path="/dashboard/employee" Component={Employee} />

      <Route path="/dashboard/presence" Component={Presence} />
      <Route path="/dashboard/presence/form" Component={PresenceForm} />

      <Route path="/dashboard/ticket" Component={Ticket} />
      <Route path="/dashboard/ticket/detail/:id" Component={TicketDetail} />

      <Route path="/dashboard/whatsapp" Component={WhatsAppPage} />
      <Route path="/dashboard/whatsapp/message" Component={WhatsAppMessagePage} />
      <Route path="/dashboard/whatsapp/number" Component={WhatsAppNumberPage} />
      <Route path="/dashboard/whatsapp/template" Component={WhatsAppTemplatePage} />
      <Route path="/dashboard/whatsapp/template/create" Component={WhatsAppTemplateCreate} />


      <Route path="/dashboard/user-manager" Component={UserManager} />
      <Route path="/dashboard/user-manager/detail/:id" Component={UserDetail} />

      <Route path="/dashboard/payment-gateway" Component={PaymentGatwayPage} />

      <Route path="/dashboard/finance/bank-account" Component={BankAccount} />
      <Route path="/dashboard/finance/report" Component={FinanceReport} />
      <Route path="/dashboard/finance/taxes" Component={TaxesPage} />
      <Route path="/dashboard/finance/report/transaction" Component={Transaction} />
      <Route path="/dashboard/finance/report/hutang" Component={Hutang} />
      <Route path="/dashboard/finance/report/piutang" Component={Piutang} />
      <Route path="/dashboard/finance/report/piutang/transactions/:user_id" Component={PiutangTransaction} />

      <Route path="/dashboard/jobdesk" Component={JobdeskPage} />
      <Route path="/dashboard/jobdesk/detail/:id" Component={JobdeskDetailPage} />
      <Route path="/dashboard/notif" Component={NotificationPage} />
      <Route path="/dashboard/setting" Component={Setting} />
      <Route path="/dashboard/wa-manager" Component={WhatsAppManager} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
